
import utils from '@/util/index'
import useClipboard from 'vue-clipboard3';
import {defineComponent, reactive, onBeforeMount, nextTick} from 'vue'
import {useRoute,useRouter} from "vue-router";
import {getDetectDiffReport} from '@/service'
import { Toast, Icon } from 'scvant';


import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
    interface State {
        isPc: number;
        photoList: object[];
        photoViewer: any;
        slideIndex: number;
        currentSlideIndex: number;
        showSwiper: boolean;
        reportCode: any;
        vin: any;
        copyTxt: string;
        oldReportCode: string;
        diffGroupList: object[];
        checkItemName: string;
    }

    export default defineComponent({
        setup(ctx: any) {
            let state: State = reactive({
                reportCode: '',
                vin: '',
                copyTxt: '',
                isPc: 0,
                oldReportCode: '',
                checkItemName: '',
                diffGroupList: [],
                slideIndex: 0,
                photoList: [],
                photoViewer: {},
                currentSlideIndex: 1,
                showSwiper: false,
            });
            state.isPc = utils.getUserBrowser()
            const {query} = useRoute();
            const {reportCode, templateCode} = query;
            state.reportCode = reportCode;
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '加载中...',
            });
            getDetectDiffReport({reportCode}).then((res: any) => {
                // console.log(res);
                state.vin = res.vin;
                state.oldReportCode = res.oldReportCode;
                let diffGroupList = JSON.parse(JSON.stringify(res.diffGroupList));
                for (let i=0;i<diffGroupList.length;i += 1) {
                    let group = diffGroupList[i];
                    let diffCount = 0;
                    for (let j=0;j<group.diffItemList.length;j += 1) {
                        let item = group.diffItemList[j];
                        if (item.oldDefect !== item.nowDefect) {
                            diffCount += 1;
                        }
                        for (let z=0;z<item.oldPhotos.length;z+=1) {
                            let oldimg = item.oldPhotos[z];
                            oldimg.defectDesc = `初检结果：（${item.oldDefect}）`;
                        }
                        for (let z=0;z<item.nowPhotos.length;z+=1) {
                            let oldimg = item.nowPhotos[z];
                            oldimg.defectDesc = `复检结果：（${item.nowDefect}）`;
                        }
                    }
                    group.diffCount = diffCount;
                }
                state.diffGroupList = diffGroupList;

                nextTick(()=>{
                    // 初始化swiper
                    state.photoViewer = new Swiper('.swiper', {
                        initialSlide: state.slideIndex,
                        keyboard: true,
                        direction: 'horizontal',
                        navigation: {
                            nextEl: '.nextBtn',
                            prevEl: '.prevBtn',
                        },
                        loop: false,
                        zoom: true,
                        preloadImages: true,
                        observer: true,// 修改swiper自己或子元素时，自动初始化swiper
                        observeParents: true,// 修改swiper的父元素时，自动初始化swiper
                        on: {
                            slideChange: function () {
                                console.log('swiperComponent--slideChange,activeIndex:', this.activeIndex);
                                state.currentSlideIndex = Number(this.activeIndex) + 1;
                            },
                        }
                    })
                })
                Toast.clear();
            }).catch((err) => {
                console.error(err)
            })
            // const {query} = useRoute()
            // const router = useRouter()
            // 判断当前机型 移动端的话带着所有参数跳转/h5 pc端的话带着所有参数跳转/pc
            
            
            return{
                state
            }
        },
        components: {
            [Icon.name]: Icon,
        },
        methods: {
            viewPhoto(data, type) {
                let oldList = data.oldPhotos;
                let oldNum = data.oldPhotos.length;
                let nowList = data.nowPhotos;
                let nowNum = data.nowPhotos.length;
                if (type=== 'old' && !oldNum ) {
                    return;
                }
                if (type=== 'now' && !nowNum) {
                    return;
                }
                if (type === 'old') {
                    this.state.slideIndex = 0;
                } else {
                    this.state.slideIndex = oldNum;
                }
                this.state.checkItemName = data.checkItemName;
                this.state.photoList = [...oldList, ...nowList];
                this.state.showSwiper = true;
                this.state.photoViewer.slideTo(this.state.slideIndex);
            },
            closeSwiper () {
                this.state.showSwiper = false;

            },
            isRed(data, type, isResult) {
                let oldval = data.oldDefect;
                let nowval = data.nowDefect;
                if (type === 'old' && oldval === '未检测') {
                    return true;
                } else if (type === 'now' && nowval === '未检测') {
                    return true;
                } else if (oldval !== nowval && oldval !== '未检测' && nowval !== '未检测' && isResult){
                    return true;
                }
                return false;
            },
            async copy () {
                const {toClipboard} = useClipboard();
                let url = `页面链接：${window.location.href}，VIN：${this.state.vin}`;
                try {
                    await toClipboard(url);
                    Toast('复制成功！');
                } catch (e) {
                    console.error(e);
                }
            }
        }
         
    })
